import type { SapUiGenericAppPageSettings } from '../../../common/page';

export interface SapUiAppV4 {
    pages: SapUiAppPageV4[] | SapUiGenericAppPageMapV4;
    _version?: string;
    settings?: object;
}

export interface SapUiGenericAppPageMapV4 {
    [key: string]: SapUiAppPageV4;
}

export interface SapUiNavDetailsV4 {
    detail?: {
        route?: string;
    };
}

export type SapUi5MultiViewPath = {
    key: string;
    annotationPath: string;
    entitySet?: string;
};

export type SapUi5MultiViewPaths = SapUi5MultiViewPath[];

export type SapUi5ALPPaths = [
    {
        primary: [
            {
                annotationPath: string;
            }
        ];
        secondary: [
            {
                annotationPath: string;
            }
        ];
        defaultPath: string;
    }
];

export type SapUi5Views = {
    paths: SapUi5MultiViewPaths | SapUi5ALPPaths;
    showCounts?: boolean;
};

export interface SapUiGenericAppPageCustomFilterField {
    label: string;
    property: string;
    required?: boolean;
    position: SapUi5RoutingTargetContentPosition;
}

export interface SapUiGenericAppPageSettingsV4 extends SapUiGenericAppPageSettings {
    ['@com.sap.vocabularies.UI.v1.SelectionFields']: SapUiGenericAppPageCustomFilterField;
}

export type SapUiPageSettingsV4 = SapUiGenericAppPageSettings & {
    entitySet?: string;
    navigation?: {
        [key: string]: SapUiNavDetailsV4;
    };
    controlConfiguration?: SapUiGenericAppPageSettingsV4;
    content?: SapUi5RoutingTargetContent;
    views?: SapUi5Views;
    defaultTemplateAnnotationPath?: string;
};

export interface SapUiAppPageV4 {
    type: string;
    id: string;
    name: string;
    options: {
        settings?: SapUiPageSettingsV4;
    };
}

export const FE_NAMESPACE_V4 = 'sap.fe';
export const FE_TEMPLATE_V4_CUSTOM_PAGE = 'sap.fe.core.fpm';
export const FE_TEMPLATE_V4_OBJECT_PAGE = 'sap.fe.templates.ObjectPage';
export const FE_TEMPLATE_V4_LIST_REPORT = 'sap.fe.templates.ListReport';
export const FE_TEMPLATE_V4_ALP = 'sap.fe.templates.AnalyticalListPage';
export interface SapUiAppPagesV4 {
    [key: string]: SapUiAppPageV4;
}
export interface SapUi5RoutingTargetContent {
    header?: object;
    body?: SapUi5RoutingTargetContentBody;
    footer?: object;
}

export interface SapUi5RoutingTargetContentBody {
    sections?: SapUi5RoutingTargetContentSections;
}

export interface SapUi5RoutingTargetContentSections {
    [key: string]: SapUi5RoutingTargetContentSection | SapUi5RoutingTargetContentSubSectionsWrapper;
}

export interface SapUi5RoutingTargetContentSubSections {
    [key: string]: SapUi5RoutingTargetContentSection;
}

export interface SapUi5RoutingTargetContentSubSectionsWrapper {
    subSections: SapUi5RoutingTargetContentSubSections;
}

export const SAPUI5_FRAGMENT_TYPE_V4 = 'XMLFragment';
export interface SapUi5RoutingTargetContentSection {
    // Currently only xml fragment is supported
    type: typeof SAPUI5_FRAGMENT_TYPE_V4;
    name?: string;
    title: string;
    position: SapUi5RoutingTargetContentPosition;
    template?: string;
    templateEdit?: string;
    actions?: object;
}

export enum SectionPositionV4 {
    AfterFacet = 'AfterFacet',
    BeforeFacet = 'BeforeFacet'
}

export interface SapUi5RoutingTargetContentPosition {
    placement: SectionPositionV4;
    anchor: string;
}
